import { render, staticRenderFns } from "./ConstructorStandingsTable.vue?vue&type=template&id=11c167b0&"
import script from "./ConstructorStandingsTable.vue?vue&type=script&lang=js&"
export * from "./ConstructorStandingsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports